import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PosterCard.css';

const PosterCard = ({ media }) => {
  const image = media.vertical_image || media.horizontal_image || '/static/placeholder.jpg';
  // const link = `/media-list/${media.type}#search=${encodeURIComponent(media.title)}`;
  const link = `/media-item/${media.id}`;

  // Map media types to icon paths (matching ExploreButtons)
  const mediaIcons = {
    SteamGame: '/static/icons/steam.svg',
    PhysicalGame: '/static/icons/gamepad-solid.svg',
    PSP: '/static/icons/gamepad-solid.svg',
    VITA: '/static/icons/playstation.svg',
    NDS: '/static/icons/nintendo-ds.svg',
    SWITCH: '/static/icons/nintendoswitch.svg',
    vinyl: '/static/icons/record-vinyl-solid.svg',
    cd: '/static/icons/compact-disc-solid.svg',
    Anime: '/static/icons/clapperboard-solid.svg',
    Manga: '/static/icons/book-solid.svg',
    Music: '/static/icons/music-solid.svg',
    ScreenMedia: '/static/icons/film-solid.svg',
    movie: '/static/icons/film-solid.svg',
    tv: '/static/icons/tv-solid.svg',
  };

  // Determine which key to use for the icon
	let iconKey = media.type;
	if(media.type === 'PhysicalGame') {
		iconKey = media.platform.toUpperCase();
	}
	if(media.type === 'Music') {
		iconKey = media.format;
	}
  if(media.type === 'ScreenMedia') {
    iconKey = media.media_format;
	}

	// Get the icon source
	const iconSrc = mediaIcons[iconKey] || '/static/icons/file-solid.svg';

  return (
    <Link to={link} className="media-poster-card">
      <div className="poster-img-wrapper">
        <img src={image} className="poster-img" alt={media.title} />
      </div>
      <div className="poster-info">
        <strong> 
          <img src={iconSrc} class="icon media-type-icon" alt={`${media.type} icon`} /> {media.title}
        </strong>
        <p>
          {media.type === 'SteamGame' && `${Math.floor((media.playtime || 0) / 60)}h played`}
          {media.type === 'Anime' && `Ep ${media.current_episode || 0}${media.episode_count ? `/${media.episode_count}` : ''}`}
          {media.type === 'Manga' && `Vol ${media.current_volume || 0}${media.volume_count ? `/${media.volume_count}` : ''}`}
          {['PhysicalGame', 'Music'].includes(media.type) && media.status}
        </p>
      </div>
    </Link>
  );
};

export default PosterCard;